// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");

function modeType(t) {
  var match = t.linkType;
  if (match === "AnonymousLink") {
    return "AnonymousLink";
  } else {
    return "QrCode";
  }
}

function empty(param) {
  return {
          id: undefined,
          token: "url",
          name: "",
          linkType: "AnonymousLink",
          customAttributes: /* [] */0
        };
}

function setToken(t, x) {
  return {
          id: t.id,
          token: x,
          name: t.name,
          linkType: t.linkType,
          customAttributes: t.customAttributes
        };
}

function setAnonymousType(t) {
  return {
          id: t.id,
          token: t.token,
          name: t.name,
          linkType: "AnonymousLink",
          customAttributes: t.customAttributes
        };
}

function setQrCodeType(t) {
  return {
          id: t.id,
          token: t.token,
          name: t.name,
          linkType: "QRCode",
          customAttributes: t.customAttributes
        };
}

function id(t) {
  return t.id;
}

function linkType(t) {
  return t.linkType;
}

function customAttributes(t) {
  return t.customAttributes;
}

function setCustomAttributes(t, attributes) {
  return {
          id: t.id,
          token: t.token,
          name: t.name,
          linkType: t.linkType,
          customAttributes: attributes
        };
}

function createAttribute(id, value) {
  return {
          id: id,
          value: value
        };
}

function name(t) {
  return t.name;
}

function setName(t, name) {
  return {
          id: t.id,
          token: t.token,
          name: name,
          linkType: t.linkType,
          customAttributes: t.customAttributes
        };
}

function validToken(x) {
  return x !== "";
}

function token(t) {
  return t.token;
}

function toForm(t) {
  return {
          id: {
            TAG: "Valid",
            _0: t.id
          },
          token: t.token !== "" ? ({
                TAG: "Valid",
                _0: t.token
              }) : ({
                TAG: "Invalid",
                _0: t.token,
                _1: {
                  hd: "Invalid URL",
                  tl: /* [] */0
                }
              }),
          name: t.name !== "" ? ({
                TAG: "Valid",
                _0: t.name
              }) : ({
                TAG: "Invalid",
                _0: t.name,
                _1: {
                  hd: "Invalid Name",
                  tl: /* [] */0
                }
              })
        };
}

function fromForm(form) {
  return {
          id: FormField$ReactHooksTemplate.getInputValue(form.id),
          token: FormField$ReactHooksTemplate.getInputValue(form.token),
          name: FormField$ReactHooksTemplate.getInputValue(form.name),
          linkType: "AnonymousLink",
          customAttributes: /* [] */0
        };
}

function categoryEncoder(category) {
  if (category === "AnonymousLink") {
    return "anonymous_link";
  } else {
    return "qr_code";
  }
}

function encodeParam(param) {
  return Json_encode.object_({
              hd: [
                "id",
                param.id
              ],
              tl: {
                hd: [
                  "value",
                  param.value
                ],
                tl: /* [] */0
              }
            });
}

function encodedDataFieldAttributes(dataFieldParams) {
  return Belt_List.toArray(Belt_List.map(dataFieldParams, encodeParam));
}

function encoder(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "link_type",
                    categoryEncoder(t.linkType)
                  ],
                  tl: {
                    hd: [
                      "custom_attributes",
                      encodedDataFieldAttributes(t.customAttributes)
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function categoryDecoder(json) {
  var match = Json_decode.string(json);
  switch (match) {
    case "anonymous_link" :
        return "AnonymousLink";
    case "qr_code" :
        return "QRCode";
    default:
      return Pervasives.failwith("Invalid category");
  }
}

function customAttributesDecoder(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          value: Json_decode.field("value", Json_decode.string, json)
        };
}

function decoder(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          token: Json_decode.field("token", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json),
          linkType: Json_decode.field("link_type", categoryDecoder, json),
          customAttributes: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("mode_attributes", (function (param) {
                                return Json_decode.list(customAttributesDecoder, param);
                              }), param);
                }), json)
        };
}

exports.modeType = modeType;
exports.empty = empty;
exports.setToken = setToken;
exports.setAnonymousType = setAnonymousType;
exports.setQrCodeType = setQrCodeType;
exports.id = id;
exports.linkType = linkType;
exports.customAttributes = customAttributes;
exports.setCustomAttributes = setCustomAttributes;
exports.createAttribute = createAttribute;
exports.name = name;
exports.setName = setName;
exports.validToken = validToken;
exports.token = token;
exports.toForm = toForm;
exports.fromForm = fromForm;
exports.categoryEncoder = categoryEncoder;
exports.encodeParam = encodeParam;
exports.encodedDataFieldAttributes = encodedDataFieldAttributes;
exports.encoder = encoder;
exports.categoryDecoder = categoryDecoder;
exports.customAttributesDecoder = customAttributesDecoder;
exports.decoder = decoder;
/* No side effect */
